import Vue from 'vue'
Vue.directive('hover', {
    bind(el){
       el.style.display=""
     
    }
  })